/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
// helpers
import moment from 'moment';
import _ from 'lodash';
// components
import {
  Divider,
  FormHelperText,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import withRouter from '../../../components/hocs/withRouter';
import { MultiSelect } from '../../../components/Selects';
import { withOneIncDependencies } from './withOneIncDependencies';
import { QuoteStepsP250, QuoteStepsP100 } from '../quotes/QuoteSteps';
// platform helpers
import { Modal } from '../../../components/modals/v2/helpers/v2.modal.helpers';
import { ACHWireTransferConfig } from './ACHWireTransfer';
import { InstallmentPlanConfig } from './InstallmentPlan';
import { SendToAccountingConfig } from './SendToAccounting';
import {
  loadOneIncByPolicyNumber,
  moneyFormat2Decimals,
  waitForJQueryPlugin,
} from '../../../utils/appUtils';
// services
import {
  getPaymentStatus,
  paymentComplete,
  savePayment,
} from '../_services/BillingService';
import { isZurichProduct, ProductTypes } from '../../../types';
import { getIsRenewalOrMigration, manageAPIError } from '../../../utils';
import { toUniversalUtcDate } from '../../../utils/date.utils';

const styles = ({ config, palette, ...theme }: any) => {
  return {
    main: {
      backgroundColor: palette.background.lighter,
      padding: '2.1667rem 2.083rem',
    },
    bodyContainer: {
      padding: '2.5rem 0 2.5rem 2rem',
      color: palette.primary.main,
      marginBottom: '2.5rem',
      display: 'flex',
    },
    horizontalLine: {
      borderBottom: `1px solid ${palette.primary.modalBorder}`,
    },
    optionContainer: {
      width: '24.5rem',
    },
    optionContentContainer: {
      textAlign: 'center',
      padding: '2rem 0 1rem 0',
      height: '9.75rem',

      '&:hover': {
        cursor: 'pointer',
        color: palette.primary.contrastText,
        fontWeight: config.weights.bold,
        backgroundColor: palette.background.green5,
      },
    },
    optionContentContainer1: {
      textAlign: 'center',
      padding: '2rem 0 1rem 0',
      height: '9.75rem',

      '&:hover': {
        cursor: 'pointer',
        color: palette.primary.contrastText,
        fontWeight: config.weights.bold,
        backgroundColor: palette.background.lightNavy,
      },
    },
    icon: {
      width: '3rem',
      height: '3rem',
    },
    optionName: {
      fontSize: '1.167rem',
      lineHeight: 1.5,
      margin: '0 !important',
    },
    optionName1: {
      fontSize: '0.833rem',
      lineHeight: 1.5,
      margin: '0 !important',
    },
    option1: {
      border: `2px solid ${palette.primary.border7}`,
      borderRadius: 5,
      color: palette.primary.contrastText,
    },
    option2: {
      color: palette.primary.contrastText,
      border: `2px solid ${palette.primary.border2}`,
      borderRadius: 5,
    },
    optionDetails: {
      color: palette.primary.contrastText,
      fontSize: '1rem',
      lineHeight: 1.33,
      padding: '0 0.7rem',
      textAlign: 'center',
    },
    emailContainer: {
      display: 'flex',
    },
    emailIcon: {
      width: '2rem',
      height: '2rem',
    },
    emailText: {
      fontSize: '1.167rem',
      lineHeight: 1.5,
      fontStyle: 'italic',
      margin: '0 !important',
      color: palette.primary.contrastText,
    },
    clickHere: {
      fontWeight: config.weights.bold,
      color: palette.primary.title,
      cursor: 'pointer',
    },
    paymentsGroup: {
      width: '100%',
    },
    group1: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    divider: {
      height: '26.8333rem',
      float: 'left',
      margin: '0 2rem',
    },
    divider1: {
      height: '18.8333rem',
      float: 'left',
      margin: '0 2rem',
    },
    rightGroup: {
      float: 'left',
      width: '24.5rem',
    },
    leftGroup: {
      float: 'left',
      width: '51rem',
      display: 'flex',
      flexDirection: 'column',
    },
    labelClass: {
      margin: '0 !important',
    },
    marginTop1: {
      marginTop: '8rem',
    },
    marginTop2: {
      marginTop: '3rem',
    },
    sectionHeader: {
      width: '100%',
      height: '3.33rem',
      lineHeight: '3.33rem',
      backgroundColor: palette.background.payment,
      marginTop: '2rem',
      padding: '0 1rem',
      color: palette.primary.contrastText,
      fontSize: config.textSizes.paragon,
      display: 'flex',
      justifyContent: 'space-between',
      '& span': {
        fontWeight: config.weights.bold,
      },
    },
    backdrop: {
      zIndex: `${theme.zIndex.drawer + 1}`,
      color: palette.text.link,
    },
  };
};

let type = '';
let tokenId: any = null;

export const OneIncPayPolicy = compose(
  withRouter,
  withOneIncDependencies(),
  // @ts-expect-error TS(2345): Argument of type '({ config, palette, ...theme }: ... Remove this comment to see the full error message
  withStyles(styles)
)(
  ({
    data,
    balance,
    downPayment,
    titleData,
    product,
    policyId,
    location,
    history,
    classes,
    ...props
  }: any) => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [oneIncKey, setKey] = useState({});
    // Read at call time instead of closed over, so a click racing ahead of
    // loadOneIncByPolicyNumber can't use a stale, empty key.
    const oneIncKeyRef = React.useRef(oneIncKey);
    const isPaymentInFlightRef = React.useRef(false);

    const paymentStatus = data[1];
    const xpress = data[2];
    const policy = data[3];
    const paymentMethods = data[4];
    const { customer } = props;
    const brokerFee = _.isUndefined(data.brokerFee) ? 0 : data.brokerFee;
    const mgaFee = _.isUndefined(data.mgaFee) ? 0 : data.mgaFee;
    const noShowExpress =
      // @ts-expect-error TS(2365): Operator '<' cannot be applied to types 'string' a... Remove this comment to see the full error message
      (0.8 * (policy.totalPremium - brokerFee - mgaFee)).toFixed(2) < 500;
    const isRenewal = _.get(policy, 'isRenewal', false);
    const isMigration = _.get(policy, 'isMigration', false);
    const isRenewalOrMigration = getIsRenewalOrMigration(
      isRenewal,
      isMigration
    );

    useEffect(() => {
      if (paymentStatus && paymentStatus.isPaid) {
        history.push('/customer/policies');
      } else if (error) {
        getPaymentStatus({ policyId }).then((resp: any) => {
          if (resp.data.isPaid) {
            history.push('/customer/policies');
          } else {
            setLoading(false);
          }
        });
      } else {
        setLoading(false);
      }
      // eslint-disable-next-line
    }, [error]);

    useEffect(() => {
      if (props.isLoaded) {
        loadOneIncByPolicyNumber(policy.policyNumber)
          .then((keyResp: any) => {
            setKey(keyResp.data);
            oneIncKeyRef.current = keyResp.data;

            window.$('#portalOneContainer').on('portalOne.unload', function () {
              getPaymentStatus({ policyId })
                .then((resp: any) => {
                  if (resp.data.isPaid) {
                    history.push('/customer/policies');
                  } else {
                    setLoading(false);
                  }
                })
                .catch(() => {
                  setLoading(false);
                });
            });

            window
              .$('#portalOneContainer')
              .on('portalOne.paymentComplete', function (e: any, d: any) {
                if (d.acknowledge) {
                  d.acknowledge();
                }

                const payload = {
                  transactionId: d.transactionId,
                  transactionDate: moment(d.transactionDate).valueOf(),
                  paymentAmount: d.paymentAmount,
                  totalPaymentAmount: d.totalPaymentAmount,
                  policyId,
                  policyNumber: policy.policyNumber,
                  lastFourDigits: _.get(
                    d,
                    'transactions[0].lastFourDigits',
                    ''
                  ),
                  customerEmail: policy.customerEmail,
                  quoteId: policy.quoteId,
                  agencyId: policy.agencyId,
                  policyCreated: policy.created,
                  bankName: d.bankName || '',
                  cardType: d.cardType || '',
                  isDownPayment: titleData.premiumFinanced,
                };

                paymentComplete({}, payload).catch((error: any) => {
                  setLoading(false);
                  setError(
                    manageAPIError(
                      error,
                      'Something went wrong while making payment. Please contact support@cowbellcyber.ai for more information'
                    )
                  );
                });
              });

            window
              .$('#portalOneContainer')
              .on('portalOne.saveComplete', function (e: any, d: any) {
                if (type === 'creditCard') {
                  const payload = {
                    tokenId: d.tokenId,
                    paymentCategory: d.paymentCategory,
                    expirationMonth: d.cardExpirationMonth,
                    expirationYear: d.cardExpirationYear,
                    creditCardType: d.cardType,
                    last4Digits: d.lastFourDigits,
                  };

                  savePayment({}, payload).catch((error: any) => {
                    setLoading(false);
                    setError(
                      manageAPIError(
                        error,
                        'Something went wrong while saving payment. Try again later.'
                      )
                    );
                  });
                } else if (type === 'bankAccount') {
                  const payload = {
                    tokenId: d.tokenId,
                    paymentCategory: d.paymentCategory,
                    last4Digits: d.lastFourDigits,
                    bankAccountType: d.accountType,
                    bankName: d.bankName,
                  };

                  savePayment({}, payload).catch((error: any) => {
                    setLoading(false);
                    setError(
                      manageAPIError(
                        error,
                        'Something went wrong while saving payment. Try again later.'
                      )
                    );
                  });
                }
              });
          })
          .catch((error: any) => {
            setLoading(false);
            setError(
              manageAPIError(
                error,
                'Something went wrong. Please contact support@cowbellcyber.ai to proceed with payment.'
              )
            );
          });
      }
      // eslint-disable-next-line
    }, []);

    const optionSelect = React.useCallback(async () => {
      if (type === 'ACH') {
        Modal.show(ACHWireTransferConfig, {
          data: {
            policyNumber: policy.policyNumber,
            ...policy.firmographicData,
          },
          config: {
            title: `Pay ${moneyFormat2Decimals(
              balance
            )} with ACH or Wire Transfer`,
          },
        });
        return null;
      }

      if (type === 'EXC') {
        Modal.show(InstallmentPlanConfig, {
          data: policy,
          config: {
            title: `INSTALLMENT PLAN for Policy# ${policy.policyNumber}`,
          },
        });
        return null;
      }

      let paymentCategory: any;
      if (type === 'creditCard') {
        paymentCategory = 'CreditCard';
      } else if (type === 'bankAccount') {
        paymentCategory = 'ECheck';
      }

      // Blocks a second click from starting its own wait + session below.
      if (isPaymentInFlightRef.current) {
        return;
      }
      isPaymentInFlightRef.current = true;

      try {
        await waitForJQueryPlugin('portalOne');
      } catch {
        isPaymentInFlightRef.current = false;
        setError(
          'Payment is not ready yet. Please wait a moment and try again, or contact support@cowbellcyber.ai if this persists.'
        );
        return;
      }

      // @ts-expect-error TS(2339): Property 'url'/'key' does not exist on type '{}'.
      if (!oneIncKeyRef.current.url || !oneIncKeyRef.current.key) {
        isPaymentInFlightRef.current = false;
        setError(
          'Payment is not ready yet. Please wait a moment and try again, or contact support@cowbellcyber.ai if this persists.'
        );
        return;
      }

      window.$('#portalOneContainer').portalOne();
      const xhttp = new XMLHttpRequest();
      xhttp.overrideMimeType('application/json');
      xhttp.onreadystatechange = function () {
        if (xhttp.readyState !== 4) {
          return;
        }

        isPaymentInFlightRef.current = false;

        if (xhttp.status === 200) {
          setLoading(true);
          const resp = JSON.parse(xhttp.responseText);
          const sessionID = resp.PortalOneSessionKey;
          window
            .$('#portalOneContainer')
            .data('portalOne')
            .makePayment({
              paymentCategory,
              feeContext: 'PaymentWithFee',
              amountContext: 'AmountDue',
              minAmountDue: balance,
              accountBalance: '0',
              // @ts-expect-error TS(2339): Property 'authCode' does not exist on type '{}'.
              accountGroupCode: oneIncKeyRef.current.authCode,
              billingZip: '',
              billingAddressStreet:
                '6800 Koll Center Pkwy. Suite 250, Pleasanton, CA',
              policyHolderName: customer.fullName,
              referenceNumber: '',
              saveOption: 'UserSelect',
              clientReferenceData1: policy.policyNumber,
              clientReferenceData2: moment(policy.created)
                .add(7, 'days')
                .format('L'), // TODO: should this date be changed?
              clientReferenceData3: titleData.premiumFinanced
                ? 'true'
                : 'false',
              clientReferenceData4: policy.id,
              clientReferenceData5: 'POL-12345-ClientReferenceData5',
              sessionId: sessionID,
              displayMode: 'modal',
              confirmationDisplay: 'true',
              ...(tokenId && { token: tokenId }),
            });
        }
      };

      xhttp.open(
        'GET',
        // @ts-expect-error TS(2339): Property 'url' does not exist on type '{}'.
        `${oneIncKeyRef.current.url}/Api/Api/Session/Create?portalOneAuthenticationKey=${oneIncKeyRef.current.key}`,
        true
      );
      xhttp.send();
      setLoading(false);
      // eslint-disable-next-line
    }, [balance, titleData]);

    const handleSelectSavedPayment = (name: any, selection: any) => {
      const { value } = selection;
      type = value.ptype;
      tokenId = value.token;
      optionSelect();
    };

    const onClickSendToAccounting = React.useCallback(() => {
      Modal.show(SendToAccountingConfig, {
        data: {
          policyNumber: policy.policyNumber,
          policyId,
          amount: balance,
          customerEmail: policy.customerEmail,
        },
      });
      // eslint-disable-next-line
    }, [balance]);

    return (
      <section className="page-container">
        {!isRenewalOrMigration ? (
          <QuoteStepper policy={policy} product={product} location={location} />
        ) : null}
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <div id="portalOneContainer" />
        <section className="main-container" style={{ height: 'unset' }}>
          <section className="header-container">
            <div className="header-title">
              {titleData.descriptionLine1}
              <br />
              {titleData.descriptionLine2}
            </div>
            <p className="header-title">
              Due Date: {toUniversalUtcDate(titleData.dueDate)}
            </p>
          </section>
          {/*
            Stays on moneyFormat2Decimals (MS-406): `balance`, `titleData` and
            `downPayment` below all trace to fir-billing endpoints
            (getBalanceOnPolicy/getTitleDesc, customers/_services/BillingService.ts)
            which per MS-409 carry no `currency` field on any payment/invoice
            response. Convert once MS-409 ships.
          */}
          {!titleData.premiumFinanced && (
            <section className={classes.sectionHeader}>
              PAY IN FULL{' '}
              <span>{moneyFormat2Decimals(titleData.dueAmount)}</span>
            </section>
          )}
          <section className={classes.bodyContainer}>
            <section className={classes.paymentsGroup}>
              <section className={classes.leftGroup}>
                {paymentMethods && paymentMethods.length > 0 && (
                  <MultiSelect
                    labelClass={classes.labelClass}
                    label="Select Payment Method"
                    options={paymentMethods}
                    onChange={handleSelectSavedPayment}
                    isMulti={false}
                    fullWidth
                    className={classes.select}
                    data-qa="ownershipType"
                  />
                )}
                <section className={classes.group1}>
                  <section
                    className={`${classes.optionContainer} ${
                      paymentMethods && paymentMethods.length > 0
                        ? classes.marginTop2
                        : ''
                    }`}
                  >
                    <section
                      className={`${classes.optionContentContainer} ${classes.option1}`}
                      onClick={() => {
                        type = 'bankAccount';
                        tokenId = null;
                        optionSelect();
                      }}
                    >
                      <img
                        alt=""
                        src="images/PayByBankAccount.svg"
                        className={classes.icon}
                      />
                      <p className={classes.optionName}>PAY BY e-CHECK</p>
                    </section>
                    <p className={classes.optionDetails}>
                      If you want to avoid the credit card processing fees,
                      please use ‘Pay by e-Check to make payment.
                    </p>
                  </section>
                  <section
                    className={`${classes.optionContainer} ${
                      paymentMethods && paymentMethods.length > 0
                        ? classes.marginTop2
                        : ''
                    }`}
                  >
                    <section
                      className={`${classes.optionContentContainer} ${classes.option1}`}
                      onClick={() => {
                        type = 'creditCard';
                        tokenId = null;
                        optionSelect();
                      }}
                    >
                      <img
                        alt=""
                        src="images/PayByCreditCard.svg"
                        className={classes.icon}
                      />
                      <p className={classes.optionName}>PAY BY CREDIT CARD</p>
                      <p className={classes.optionName1}>
                        Using <span style={{ fontWeight: 600 }}>One Inc</span>,
                        a third party payment processor
                      </p>
                    </section>
                    <p className={classes.optionDetails}>
                      I understand and agree that by clicking ‘Pay by Credit
                      Card’ I am leaving the Cowbell Cyber platform to make a
                      payment in a One Inc payment input form. One Inc is the
                      third-party payment solutions provider that will make a
                      payment to Cowbell Cyber on my behalf.
                    </p>
                  </section>
                </section>
              </section>
              <Divider
                orientation="vertical"
                flexItem
                classes={{
                  root:
                    data.payments && data.payments.length > 0
                      ? classes.divider
                      : classes.divider1,
                }}
              />
              <section
                className={`${classes.rightGroup} ${
                  data.payments && data.payments.length > 0
                    ? classes.marginTop1
                    : ''
                }`}
              >
                <section
                  className={`${classes.optionContentContainer1} ${classes.option2}`}
                  onClick={() => {
                    type = 'ACH';
                    optionSelect();
                  }}
                >
                  <img
                    alt=""
                    src="images/PayByACH_Wire.svg"
                    className={classes.icon}
                  />
                  <p className={classes.optionName}>ACH/WIRE TRANSFER</p>
                </section>
                <p className={classes.optionDetails}>
                  If you would like to directly make the payment to Cowbell
                  Cyber’s bank account, use this option to get the routing
                  number, account number and bank details.
                </p>
              </section>
            </section>
          </section>
          {error && (
            <FormHelperText
              className="api-text-error"
              style={{ textAlign: 'end' }}
            >
              {error}
            </FormHelperText>
          )}
          {xpress &&
            !titleData.premiumFinanced &&
            !noShowExpress &&
            !isZurichProduct(product) && (
              <>
                <section className={classes.sectionHeader}>
                  INSTALLMENT PLAN{' '}
                  <span>Down Payment: {moneyFormat2Decimals(downPayment)}</span>
                </section>
                <section
                  className={`${classes.bodyContainer} ${classes.horizontalLine}`}
                >
                  <section className={classes.paymentsGroup}>
                    <section className={`${classes.rightGroup}`}>
                      <section
                        className={`${classes.optionContentContainer1} ${classes.option2}`}
                        onClick={() => {
                          type = 'EXC';
                          optionSelect();
                        }}
                      >
                        <img
                          alt=""
                          src="images/financingPlan.svg"
                          className={classes.icon}
                        />
                        <p className={classes.optionName}>INSTALLMENT PLAN</p>
                        <p className={classes.optionName1}>
                          Using Xpress Capital
                        </p>
                      </section>
                      <p className={classes.optionDetails}>
                        If you would like to use premium financing to make
                        payments in 10 installments, use this option
                      </p>
                    </section>
                  </section>
                </section>
              </>
            )}
          <section className={classes.emailContainer}>
            <img alt="" src="images/email.svg" className={classes.emailIcon} />
            <p className={classes.emailText}>
              If you would like someone else in your organization to handle the
              payment,{' '}
              <span
                className={classes.clickHere}
                onClick={onClickSendToAccounting}
              >
                click here.
              </span>
            </p>
          </section>
        </section>
      </section>
    );
  }
);

const QuoteStepper = ({ policy, product, location }: any) => {
  if (!policy.firmographicData?.agencyBilled) {
    if (product === ProductTypes.p100) {
      return (
        <QuoteStepsP100
          location={location}
          agencyBilled={policy.firmographicData.agencyBilled}
        />
      );
    }
    if (product === ProductTypes.p250) {
      return (
        <QuoteStepsP250
          location={location}
          agencyBilled={policy.firmographicData?.agencyBilled}
        />
      );
    }
  }
  return <></>;
};
